<script lang="ts">
  import type { SearchResult } from './types';
  const DEFAULT_IMAGE_URL =
    'https://d6ce0no7ktiq.cloudfront.net/images/attachment/2023/10/03/dafdd3184cfdeddbff2f774d9f9a1c4b82677729.jpg';

  const { item, onClick }: { item: SearchResult; onClick: () => void } = $props();
  const { image_url, categories, header, content } = item;

  function getUrl(result: SearchResult) {
    return `${result.url}?search=${encodeURIComponent(result.header)}`;
  }
</script>

<li
  class="flex scale-100 flex-col border-b border-gray-200 py-3 transition-transform duration-200 ease-in-out will-change-transform last:border-b-0 hover:scale-105 hover:bg-gray-100 md:py-0"
>
  <a
    class="flex h-40 items-center gap-4 p-3 text-gray-700 no-underline"
    href={getUrl(item)}
    onclick={onClick}
  >
    <div class="hidden h-[110px] w-[110px] flex-shrink-0 sm:block">
      <img
        src={image_url || DEFAULT_IMAGE_URL}
        alt={header}
        class="h-full w-full rounded-full bg-white/30 object-contain"
      />
    </div>
    <div class="flex flex-col">
      <span class="text-sm font-bold uppercase text-gray-500">
        {categories[0]}
      </span>
      <span class="text-xl font-bold">
        {header}
      </span>
      <span class="line-clamp-3 text-gray-700">
        {content}
      </span>
    </div>
  </a>
</li>

<style>
  .will-change-transform {
    will-change: transform;
  }
</style>
